enum Colors {
    black = "#212121"
}

export default Colors;
